/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GroupListResponse,
  GroupResponse,
  StringListResponse,
} from '../models/index';
import {
    GroupListResponseFromJSON,
    GroupListResponseToJSON,
    GroupResponseFromJSON,
    GroupResponseToJSON,
    StringListResponseFromJSON,
    StringListResponseToJSON,
} from '../models/index';

export interface AddUsersToGroupRequest {
    groupId: string;
    requestBody: Array<string>;
    sessionId?: string;
}

export interface AssignRolesToGroupRequest {
    groupId: string;
    requestBody: Array<string>;
    sessionId?: string;
}

export interface CreateGroupRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DeleteGroupRequest {
    id: string;
    sessionId?: string;
}

export interface GetGroupRequest {
    id: string;
    sessionId?: string;
}

export interface GetGroupRolesRequest {
    groupId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetGroupUsersRequest {
    groupId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetGroupsRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    name?: string;
    sessionId?: string;
}

export interface GetUserGroupsRequest {
    userId: string;
    sessionId?: string;
}

export interface RemoveRolesFromGroupRequest {
    groupId: string;
    requestBody: Array<string>;
    sessionId?: string;
}

export interface RemoveUsersFromGroupRequest {
    groupId: string;
    requestBody: Array<string>;
    sessionId?: string;
}

export interface UpdateGroupRequest {
    id: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * GroupsApi - interface
 * 
 * @export
 * @interface GroupsApiInterface
 */
export interface GroupsApiInterface {
    /**
     * Adds multiple users to a group
     * @summary Add users to group
     * @param {string} groupId Group ID
     * @param {Array<string>} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    addUsersToGroupRaw(requestParameters: AddUsersToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Adds multiple users to a group
     * Add users to group
     */
    addUsersToGroup(requestParameters: AddUsersToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Assigns multiple roles to a group
     * @summary Assign roles to group
     * @param {string} groupId Group ID
     * @param {Array<string>} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    assignRolesToGroupRaw(requestParameters: AssignRolesToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Assigns multiple roles to a group
     * Assign roles to group
     */
    assignRolesToGroup(requestParameters: AssignRolesToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Creates a new group in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from groupData matches session tenant): - User creates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from groupData differs from session tenant): - Parent/system admin creates group for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Create group
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    createGroupRaw(requestParameters: CreateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Creates a new group in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from groupData matches session tenant): - User creates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from groupData differs from session tenant): - Parent/system admin creates group for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create group
     */
    createGroup(requestParameters: CreateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Deletes a group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User deletes group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin deletes group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Delete group
     * @param {string} id Group ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    deleteGroupRaw(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User deletes group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin deletes group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Delete group
     */
    deleteGroup(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves a specific group by ID
     * @summary Get group by ID
     * @param {string} id Group ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    getGroupRaw(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Retrieves a specific group by ID
     * Get group by ID
     */
    getGroup(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Retrieves all roles assigned to a specific group
     * @summary Get group roles
     * @param {string} groupId Group ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    getGroupRolesRaw(requestParameters: GetGroupRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all roles assigned to a specific group
     * Get group roles
     */
    getGroupRoles(requestParameters: GetGroupRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all users in a specific group
     * @summary Get group users
     * @param {string} groupId Group ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    getGroupUsersRaw(requestParameters: GetGroupUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all users in a specific group
     * Get group users
     */
    getGroupUsers(requestParameters: GetGroupUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves paginated list of groups
     * @summary Get groups
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [name] Name filter
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    getGroupsRaw(requestParameters: GetGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Retrieves paginated list of groups
     * Get groups
     */
    getGroups(requestParameters: GetGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Retrieves all groups a user belongs to
     * @summary Get user groups
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    getUserGroupsRaw(requestParameters: GetUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Retrieves all groups a user belongs to
     * Get user groups
     */
    getUserGroups(requestParameters: GetUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Removes multiple roles from a group
     * @summary Remove roles from group
     * @param {string} groupId Group ID
     * @param {Array<string>} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    removeRolesFromGroupRaw(requestParameters: RemoveRolesFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Removes multiple roles from a group
     * Remove roles from group
     */
    removeRolesFromGroup(requestParameters: RemoveRolesFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Removes multiple users from a group
     * @summary Remove users from group
     * @param {string} groupId Group ID
     * @param {Array<string>} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    removeUsersFromGroupRaw(requestParameters: RemoveUsersFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Removes multiple users from a group
     * Remove users from group
     */
    removeUsersFromGroup(requestParameters: RemoveUsersFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Updates an existing group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User updates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin updates group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * @summary Update group
     * @param {string} id Group ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApiInterface
     */
    updateGroupRaw(requestParameters: UpdateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Updates an existing group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User updates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin updates group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update group
     */
    updateGroup(requestParameters: UpdateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

}

/**
 * 
 */
export class GroupsApi extends runtime.BaseAPI implements GroupsApiInterface {

    /**
     * Adds multiple users to a group
     * Add users to group
     */
    async addUsersToGroupRaw(requestParameters: AddUsersToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling addUsersToGroup().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling addUsersToGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups/{groupId}/users`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Adds multiple users to a group
     * Add users to group
     */
    async addUsersToGroup(requestParameters: AddUsersToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.addUsersToGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns multiple roles to a group
     * Assign roles to group
     */
    async assignRolesToGroupRaw(requestParameters: AssignRolesToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling assignRolesToGroup().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling assignRolesToGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups/{groupId}/roles`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Assigns multiple roles to a group
     * Assign roles to group
     */
    async assignRolesToGroup(requestParameters: AssignRolesToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.assignRolesToGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new group in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from groupData matches session tenant): - User creates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from groupData differs from session tenant): - Parent/system admin creates group for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create group
     */
    async createGroupRaw(requestParameters: CreateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new group in the specified tenant context. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (tenantId from groupData matches session tenant): - User creates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (tenantId from groupData differs from session tenant): - Parent/system admin creates group for child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to target tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Create group
     */
    async createGroup(requestParameters: CreateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.createGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User deletes group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin deletes group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Delete group
     */
    async deleteGroupRaw(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User deletes group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin deletes group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Delete group
     */
    async deleteGroup(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves a specific group by ID
     * Get group by ID
     */
    async getGroupRaw(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific group by ID
     * Get group by ID
     */
    async getGroup(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.getGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all roles assigned to a specific group
     * Get group roles
     */
    async getGroupRolesRaw(requestParameters: GetGroupRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups/{groupId}/roles`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all roles assigned to a specific group
     * Get group roles
     */
    async getGroupRoles(requestParameters: GetGroupRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getGroupRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all users in a specific group
     * Get group users
     */
    async getGroupUsersRaw(requestParameters: GetGroupUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups/{groupId}/users`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all users in a specific group
     * Get group users
     */
    async getGroupUsers(requestParameters: GetGroupUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getGroupUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of groups
     * Get groups
     */
    async getGroupsRaw(requestParameters: GetGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of groups
     * Get groups
     */
    async getGroups(requestParameters: GetGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.getGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all groups a user belongs to
     * Get user groups
     */
    async getUserGroupsRaw(requestParameters: GetUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserGroups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/groups/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all groups a user belongs to
     * Get user groups
     */
    async getUserGroups(requestParameters: GetUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.getUserGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes multiple roles from a group
     * Remove roles from group
     */
    async removeRolesFromGroupRaw(requestParameters: RemoveRolesFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling removeRolesFromGroup().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling removeRolesFromGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups/{groupId}/roles`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Removes multiple roles from a group
     * Remove roles from group
     */
    async removeRolesFromGroup(requestParameters: RemoveRolesFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.removeRolesFromGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes multiple users from a group
     * Remove users from group
     */
    async removeUsersFromGroupRaw(requestParameters: RemoveUsersFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling removeUsersFromGroup().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling removeUsersFromGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups/{groupId}/users`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Removes multiple users from a group
     * Remove users from group
     */
    async removeUsersFromGroup(requestParameters: RemoveUsersFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.removeUsersFromGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User updates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin updates group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update group
     */
    async updateGroupRaw(requestParameters: UpdateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGroup().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing group. Supports both self-service and cross-tenant administration.  **Self-Service Mode** (group\'s tenant matches session tenant): - User updates group in their own tenant - Uses existing RLS context from session  **Cross-Tenant Admin Mode** (group\'s tenant differs from session tenant): - Parent/system admin updates group in child tenant - Validates hierarchical access via tenant relationships - Temporarily switches RLS context to group\'s tenant for write operation  Access is controlled by RBAC permissions and tenant relationships. 
     * Update group
     */
    async updateGroup(requestParameters: UpdateGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.updateGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
